'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pubSubInstance = null;
var Chance = require('chance');

var PubSub = function () {
	function PubSub() {
		_classCallCheck(this, PubSub);

		if (!pubSubInstance) {
			this.subscribers = {};
			this.tokenTopics = {};

			pubSubInstance = this;
			this.tokenGenerator = new Chance();
		}
		return pubSubInstance;
	}

	/**
  * @return {String}
  *
  * Generate token for usage in subscriptions.
  */


	_createClass(PubSub, [{
		key: '_generateToken',
		value: function _generateToken() {
			return this.tokenGenerator.guid();
		}

		/**
   * @param  {String}
   * @param  {Object}
   *
   * Publish data or changes to subscribed topic.
   */

	}, {
		key: 'publish',
		value: function publish(topic, data) {

			if (!this.subscribers[topic]) return;

			var subscriptions = this.subscribers[topic];

			Object.keys(subscriptions).forEach(function (key) {
				subscriptions[key](data);
			});
		}

		/**
   * @param  {String}
   * @param  {Function}
   * @return {String}
   *
   * Subscribe to topic and pass in callback function to be called
   * when topic is updated.
   * 
   */

	}, {
		key: 'subscribe',
		value: function subscribe(topic, callback) {

			var subscriptionToken = this._generateToken();

			if (!this.subscribers[topic]) {
				this.subscribers[topic] = {};
			}

			this.subscribers[topic][subscriptionToken] = callback;
			this.tokenTopics[subscriptionToken] = topic;

			return subscriptionToken;
		}

		/**
   * @param  {String}
   *
   * Unsubscribe from topic by using the subscription token.
   */

	}, {
		key: 'unsubscribe',
		value: function unsubscribe(subscriptionToken) {

			if (!subscriptionToken) return;

			var topic = this.tokenTopics[subscriptionToken];

			if (topic) {
				delete this.subscribers[topic][subscriptionToken];
				delete this.tokenTopics[subscriptionToken];
			}
		}
	}]);

	return PubSub;
}();

pubSubInstance = new PubSub();

exports.default = pubSubInstance;